<template>
  <div class="zcontainer" v-if="gallery">
    <div class="sub-header">
      <div class="columns sub-header-columns">
        <div class="column">
          <div class="flex">
            <router-link to="/">
              <img src="../assets/findupix-logo-svg.svg" class="brand" />          
              </router-link>
            <h1 class="title">{{ gallery.name }}</h1>
          </div>
          
        
        </div>
        <div class="column">
          <div class="buttons is-pulled-right">      
            <!-- <input v-if="canSearch" id="search" class="input search-input" type="text" v-model="search" @input="searchChange" placeholder="Search" /> -->

            <i
              class="material-icons"
              v-on:click="doUpdateCounters"
              title="Actualizar"
              >refresh</i
            >
            <i
              class="material-icons"
              v-on:click="showSearchPopup"
              title="Buscar todo / Buscar dorsal"
              >search</i>
            <!-- <i
              class="material-icons"
              v-on:click="showUpload = !showUpload"
              title="Subir fotos"
              >cloud_upload</i
            > -->
            <i
              class="material-icons"
              v-on:click="tableView = !tableView"
              title="Tabla/Fotos"
              >calendar_view_month</i
            >
            <i
              class="material-icons"
              v-bind:class="{
                'has-text-grey-light': selected.length === 0 || detectingText || userProfile.role !== 'admin',
              }"
              v-on:click="detectText"
              >rtt</i
            >
            <i
              class="material-icons"
              v-on:click="selectAllImages"
              title="Seleccionar todas"
              >done_all</i
            >
            <i
              class="material-icons"
              v-on:click="selectNoneImages"
              title="Deseleccionar"
              >remove_done</i
            >
            <i
              class="material-icons"
              v-on:click="editMultiple"
              title="Edición múltiple"
              v-bind:class="{
                'has-text-grey-light': selected.length === 0 || userProfile.role !== 'admin',
              }"
              >edit</i
            >
            <i
              class="material-icons"
              title="Borrar"
              v-bind:class="{ 'has-text-grey-light': selected.length === 0 || userProfile.role !== 'admin' }"
              v-on:click="deleteFiles"
              >delete</i
            >            
          
          </div>
        </div>
      </div>
      <div class="stats">
        <span
          class="tag is-primary"
          v-on:click="filterImages('')"
          v-bind:class="{ 'tag-selected': filter === '' }"
        >
          {{ totalImagesInit }} fotos</span
        >
        
        <span
          class="tag is-white"
          v-if="untrackedImagesLen"
          v-bind:class="{ 'tag-selected': filter === 'none' }"
          v-on:click="filterImages('none')"
        >
          {{ untrackedImagesLen }}
          sin procesar</span
        >
        <span
          class="tag is-warning"
          v-if="pendingImagesLen"
          v-on:click="filterImages('pending')"
          v-bind:class="{ 'tag-selected': filter === 'pending' }"
        >
          {{ pendingImagesLen }} pendientes</span
        >
        <span
          class="tag is-success"
          v-bind:class="{ 'tag-selected': filter === 'done-ok' }"
          v-on:click="filterImages('done-ok')"
          v-if="doneOkImagesLen"
        >
          {{ doneOkImagesLen }} OK</span
        >
        <span
          class="tag is-danger"
          v-bind:class="{ 'tag-selected': filter === 'done-ko', 'timelapse': loading }"
          v-on:click="filterImages('done-ko')"
          v-if="doneKoImagesLen"
        >
          {{ doneKoImagesLen }} KO</span
        >
        <span
          class="tag is-success"
          v-bind:class="{ 'tag-selected': filter === 'reviewed' , 'timelapse': loading }"
          v-on:click="filterImages('reviewed')"
          v-if="reviewedImagesLen"
        >
          {{ reviewedImagesLen }} revisadas</span
        >

        <span
          class="tag is-warning"
          v-bind:class="{ 'tag-selected': filter === 'not-reviewed', 'timelapse': loading }"
          v-on:click="filterImages('not-reviewed')"
          v-if="notReviewedImagesLen"
        >
          {{ notReviewedImagesLen }} no revisadas</span
        >
        <span
          class="tag is-warning"
          v-bind:class="{ 'tag-selected': filter === 'starred' }"
          v-on:click="filterImages('starred')"
          v-if="starredImagesLen"
        >
          {{ starredImagesLen }} destacadas</span
        >
        <span
          class="tag is-info"
          v-on:click="filterImages('selected')"
          v-bind:class="{ 'tag-selected': filter === 'selected' }"
          v-if="selected.length > 0"
        >
          {{ selected.length }} selected</span
        >

        <span
          class="tag is-info tag-selected"          
          v-bind:class="{ 'tag-selected': filter === 'selected' }"
          v-if="customSearch !== null"
        >
          Búsqueda</span
        >


        

        <!-- <span
          class="tag is-info clickable"
          style="vertical-align:-6px"
          v-if="shouldUpdateCounters"
          v-on:click="doUpdateCounters"
          title="Actualizar contadores"
          >
          <i class="material-icons" >sync_problem</i>                    
          </span
        > -->

        <i v-if="loading || shouldUpdateCounters" class="material-icons spin">timelapse</i>      

        <button class="pager material-icons is-pulled-right" v-bind:class="{ disabled: tableOptions.page == maxPage }" v-bind:disabled="loadingImages || tableOptions.page == maxPage" @click="pagerNext">
        keyboard_arrow_right
        </button>

        <button class="pager material-icons is-pulled-right" v-bind:class="{ disabled: tableOptions.page == 1 }" v-bind:disabled="loadingImages || tableOptions.page == 1" @click="pagerPrev">
        keyboard_arrow_left
        </button>

        <span class="tag is-white is-pulled-right">
          {{ itemsStatus }}
        </span>
      </div>
    </div>

    

    <section id="gallery" v-if="gallery" class="container">
      <file-upload
        v-if="showUpload"
        class="has-margin-bottom-2"
        v-bind:accept="'image/*'"
        v-bind:prefix="'galleries'"
        v-bind:gallery-id="gallery.id"
        v-bind:gallery="gallery"
        v-bind:multiple="true"
        @uploaded="onUploaded"
      ></file-upload>


      

      <div class="row row-v-data-table" v-if="tableView">
        <v-data-table
          :headers="headers"
          :items="images"
          :footer-props="{
            'items-per-page-options': [50, 100, 250, 1000, -1],
          }"
          :server-items-length="customSearch == null ? totalImages : undefined"
          :items-per-page="50"
          show-select
          item-key="id"
          v-model="selected"
          :single-select="false"
          class="elevation-1"
          @update:options="onDataFooterUpdate"
          @current-items="currentItems"
          :options.sync="tableOptions"          
        >
          <!-- <template v-slot:top>
            :search="search"
          :custom-filter="filterByNumber"
            <v-text-field
              v-on:input="debouncedFilter"
              :input="search"
              :label="canSearch ? 'Buscar dorsal' : 'Buscar todo'"
              class="mx-4"
            ></v-text-field>
          </template> -->
          <template v-slot:[`item.name`]="{ item }">
            <span v-on:click="showPopup(item)" class="name">{{
              item.name
            }}</span>
          </template>
          <template v-slot:[`item.exif.createDate`]="{ item }">
            <span v-on:click="showPopup(item)" class="name">{{ item.exif ? item.exif.createDate : '' }}</span>
          </template>
          <template v-slot:[`item.id`]="{ item }">
            <span v-on:click="showPopup(item)" class="name">{{ item.id }}</span>
          </template>          
          <template v-slot:[`item.reviewed_sort`]="{ item }">
            <span class="material-icons">{{
              item.reviewed ? "check" : "clear"
            }}</span>
          </template>
          <template v-slot:[`item.search`]="{ item }">
            <span class="tag is-grey" v-for="(s, i) in item.search" :key="i">
              {{s}}
            </span>
          </template>
          <template v-slot:[`item.numbers`]="{ item }">
            <span class="tag is-grey" v-for="(s, i) in item.numbers" :key="i">
              {{s}}
            </span>
          </template>
          <template v-slot:[`item.numbers_ok_sort`]="{ item }">
            <div
              class="tag tag-circle"
              v-on:click="selectImage(item)"
              v-bind:class="{
                spin: item.detectText === 'pending',
                'is-warning': item.detectText === 'pending',
                'is-success':
                  item.detectText === 'done-ok' &&
                  item.numbers &&
                  item.numbers.length > 0,
                'is-danger': item.numbers && item.numbers.length == 0,
              }"
            >
              <i class="material-icons has-text-black">rtt</i>              
            </div>
          </template>
        </v-data-table>
      </div>

      <div class="gallery columns is-multiline is-mobile" v-if="!tableView">
        <!-- <pre>{{ filteredImages }}</pre> -->

        <div
          class="column is-one-quarter"
          v-for="(image, i) in currentVisibleItems"
          v-bind:key="i"
        >
          <gallery-image
            :image="image"
            :gallery-id="galleryId"
            :gallery="gallery"
            :selected="selected.find((i) => i.id == image.id) != null"
            :current-visible-items="currentVisibleItems"
          />
        </div>
      </div>
      <gallery-image-pop-up @close="modalClosed" />
      <search-pop-up @search="doSearch" />      
    </section>

  </div>
</template>

<script>
import FileUpload from "@/components/FileUpload.vue";
import GalleryImage from "@/components/GalleryImage.vue";
import GalleryImagePopUp from "@/components/GalleryImagePopUp.vue";
import SearchPopUp from "@/components/SearchPopUp.vue";
import { mapState } from "vuex";
import { deleteFile } from "../services/file-upload.service";
const fb = require("../firebase");
import axios from "axios";
import { EventBus } from "../services/event-bus.js";
import { debounce } from "debounce";
import firebase from "firebase";
import { getAllImages } from '../workers/getallimages.worker'

export default {
  components: {
    FileUpload,
    GalleryImage,
    GalleryImagePopUp,
    SearchPopUp
  },
  data() {
    return {
      tableView: true,
      images: [],
      allImages: [],
      galleryId: '',
      gallery: null,
      galleryName: '',
      showSuccess: false,
      selected: [],
      showUpload: false,
      filter: '',
      filterInfo: '',      
      sortByInfo: '',
      sortDescInfo: '',
      customSearchInfo: '',
      itemsPerPageInfo: 0,
      pagesInfo: [''],
      pagesInfoName: [''],
      maxElements: 99999,
      detectingText: false,
      headers: [
        {
          text: "Nombre",
          align: "start",
          value: "name",
        },
        { text: "ID", value: "id" },
        { text: "Fecha creación EXIF", value: "exif.createDate" },
        { text: "Detección", value: "numbers_ok_sort" },
        { text: "Dorsales", value: "numbers", sortable: false },
        { text: "Etiquetas", value: "search", sortable: false },
        { text: "Revisada", value: "reviewed_sort" },
      ],
      tableOptions: {},
      currentVisibleItems: [],
      reloadView: false,
      search: '',
      canSearch: false,
      totalImages: 0,
      totalImagesInit: 0,
      loading: false,
      loadingImages: false,
      untrackedImagesLen: 0,
      pendingImagesLen: 0,
      doneOkImagesLen: 0,
      doneKoImagesLen: 0,
      reviewedImagesLen: 0,
      notReviewedImagesLen: 0,
      starredImagesLen: 0,
      shouldUpdateCounters: false,
      updateCountersInterval: null,
      updatingCounters: false,
      customSearch: null
    };
  },
  computed: {
    ...mapState(["userProfile", "galleries"]),    
    // filteredImages() {
    //   if (this.filter === "pending") {
    //     return this.galleryImages.filter((i) => i.detectText === this.filter);
    //   }
    //   if (this.filter === "none") {
    //     return this.galleryImages.filter((i) => i.detectText === "none");
    //   }
    //   if (this.filter === "done-ok") {
    //     return this.galleryImages.filter(
    //       (i) => i.detectText === "done-ok" && i.numbers && i.numbers.length > 0
    //     );
    //   }
    //   if (this.filter === "done-ko") {
    //     return this.galleryImages.filter(
    //       (i) =>
    //         i.detectText === "done-ok" && i.numbers && i.numbers.length == 0
    //     );
    //   }
    //   if (this.filter === "selected") {
    //     return this.galleryImages.filter(
    //       (i) => this.selected.find((s) => s.id == i.id) != null
    //     );
    //   }
    //   if (this.filter === "reviewed") {
    //     return this.galleryImages.filter((i) => i.reviewed === true);
    //   }
    //   if (this.filter === "not-reviewed") {
    //     return this.galleryImages.filter((i) => !(i.reviewed === true));
    //   }
    //   if (this.filter === "starred") {
    //     return this.galleryImages.filter((i) => i.starred === true);
    //   }
      

    //   return this.galleryImages;
    // },
    galleryImages() {
      return this.images.filter((i) => i.galleryId === this.galleryId);
    },
    untrackedImages() {
      return this.allImages.filter(
        (i) => i.galleryId === this.galleryId && i.detectText === "none"
      );
    },
    pendingImages() {
      return this.allImages.filter(
        (i) => i.galleryId === this.galleryId && i.detectText === "pending"
      );
    },
    doneOkImages() {
      return this.allImages.filter(
        (i) =>
          i.galleryId === this.galleryId &&
          i.detectText === "done-ok" &&
          i.numbers &&
          i.numbers.length > 0
      );
    },
    doneKoImages() {
      return this.allImages.filter(
        (i) =>
          i.galleryId === this.galleryId &&
          i.detectText &&
          i.detectText === "done-ok" &&
          i.numbers &&
          i.numbers.length === 0
      );
    },
    reviewedImages() {
      return this.allImages.filter(
        (i) => i.galleryId === this.galleryId && i.reviewed === true
      );
    },
    notReviewedImages() {
      return this.allImages.filter(
        (i) => i.galleryId === this.galleryId && !(i.reviewed === true)
      );
    },
    starredImages() {
      return this.allImages.filter(
        (i) => i.galleryId === this.galleryId && i.starred === true
      );
    },
    itemsStatus() {
      let initial = ( (this.tableOptions.page - 1)*this.tableOptions.itemsPerPage ) + 1 
      let last = ( (this.tableOptions.page)*this.tableOptions.itemsPerPage )
      last = this.totalImages < last ? this.totalImages : last;
      // let max = this.filteredImages.length;
      let status = `${initial}-${last} of ${this.totalImages}`;
      return status
    },
    maxPage() {
      return Math.ceil( this.totalImages / this.tableOptions.itemsPerPage );
    }    
  },
  watch: {
    tableOptions: {
      handler () {
        if (this.customSearch === null) {
          this.getImages()
        }
      },
      deep: true,
    },
  },
  async mounted() {
    console.log('mounted!')
    if (this.$route.params.id) {
      this.galleryId = this.$route.params.id;
      this.viewGallery();

      EventBus.$on("select-image", (info) => {
        this.selectImage(info.image);
      });

      EventBus.$on("delete-detection", (info) => {
        this.selectImage(info.image);
      });

      EventBus.$on('file-uploaded', (fileInfo) => {
        //this.reloadImageView();
        this.tableView = true
      });

      EventBus.$on('updated-from-modal', () => {
        this.reloadImageView();
        this.shouldUpdateCounters = true
      });

      this.getImages();
      this.updateCounters();

      this.updateCountersInterval = setInterval(() => {
        if (this.shouldUpdateCounters && !this.updatingCounters) {
          this.doUpdateCounters();
        }
      }, 10 * 1000)
      
      
    }
  },
  beforeDestroy() {
      console.log('destroyed')
      this.shouldUpdateCounters = false;
      if (this.updateCountersInterval) {
        clearInterval(this.updateCountersInterval)
      }      
  },
  methods: {
    async doUpdateCounters() {
      this.updatingCounters = true
      await this.updateCounters()
      this.updatingCounters = false
    },
    async updateCounters() {
      this.loading = true
      const allImagesArray = await getAllImages(this.galleryId)
      // console.log('getAllImagesMsg', allImagesArray)
      const allImages = allImagesArray

      this.untrackedImagesLen = allImages.filter((i) => i.galleryId === this.galleryId && i.detectText === "none").length
      this.pendingImagesLen = allImages.filter((i) => i.galleryId === this.galleryId && i.detectText === "pending").length
      this.doneOkImagesLen = allImages.filter(
        (i) =>
          i.galleryId === this.galleryId &&
          i.detectText === "done-ok" &&
          i.numbers &&
          i.numbers.length > 0
      ).length

      this.doneOkImagesLen = allImages.filter(
        (i) =>
          i.galleryId === this.galleryId &&
          i.detectText &&
          i.detectText === "done-ok" &&
          i.numbers &&
          i.numbers.length > 0
      ).length
      
      this.doneKoImagesLen = allImages.filter(
        (i) =>
          i.galleryId === this.galleryId &&
          i.detectText &&
          i.detectText === "done-ok" &&
          i.numbers &&
          i.numbers.length === 0
      ).length

      this.reviewedImagesLen = allImages.filter(
        (i) => i.galleryId === this.galleryId && i.reviewed === true
      ).length

      this.notReviewedImagesLen = allImages.filter(
        (i) => i.galleryId === this.galleryId && (!i.reviewed || i.reviewed === false)
      ).length;

      this.starredImagesLen = allImages.filter(
        (i) => i.galleryId === this.galleryId && i.starred === true
      ).length;

      this.totalImagesInit = allImages.length
      this.shouldUpdateCounters = false
      this.loading = false;
    },
    filterByNumber (value, search, item) {
      // console.log('value', value, typeof value)
      if (this.canSearch) {        
        return (value != null && search != null && item.numbers.indexOf(search) >= 0)
      }
      
      return (value != null && search != null && item.numbers.indexOf(search) >= 0) ||  (value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1)

      // return value != null &&
      //     search != null &&
      //     typeof value === 'object' &&
      //     value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
      
      // console.log('value', value)
      //   return value != null &&
      //     search != null &&
      //     typeof value === 'string' &&
      //     value.toString().toLocaleUpperCase().indexOf(search) !== -1
    },
    // getImagesSnapshot() {
    //   fb.imagesCollection
    //     .where("galleryId", "==", this.galleryId)
    //     .orderBy("createdOn", "desc")
    //     .onSnapshot((snapshot) => {
    //       let imagesArray = [];

    //       snapshot.forEach((doc) => {
    //         let image = doc.data();
    //         image.id = doc.id;

    //         image.detectTextState = this.setDetectTextState(image);

    //         imagesArray.push(image);
    //       });

    //       //store.commit('setImages', imagesArray)
    //       this.images = imagesArray;
    //     });
    // },
    // async getAllImages() {
    //   let query = await fb.imagesCollection.where("galleryId", "==", this.galleryId)
    //   console.log('getAllImages 0')
    //   const docs = await query.get()

    //   const imagesArray = [];
    //   docs.forEach((doc) => {
    //     let image = doc.data();
    //     image.id = doc.id;
    //     //image.detectTextState = this.setDetectTextState(image);
    //     imagesArray.push(image);        
    //   })
    //   console.log('getAllImages imagesArray', imagesArray)
    //   return imagesArray

    // },
    async getImages () {
      this.loadingImages = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions

      let query = await fb.imagesCollection.where("galleryId", "==", this.galleryId)
      let sortByField = 'name'

      let imagesLen = -1;

      if (this.filter === 'reviewed') {
        query = query.where('reviewed', '==', true)
        imagesLen = this.reviewedImagesLen
      }
      else if (this.filter === 'not-reviewed') {
        query = query.where('reviewed', '==', false)
        imagesLen = this.notReviewedImagesLen
      }
      else if (this.filter === 'pending') {
        query = query.where('detectText', '==', 'pending')
        imagesLen = this.pendingImagesLen
      }
      else if (this.filter === 'done-ok') {
        query = query.where('numbers_ok', '==', true)
        imagesLen = this.doneOkImagesLen
      }
      else if (this.filter === 'done-ko') {
        query = query.where('numbers_ok', '==', false)
        imagesLen = this.doneKoImagesLen
      }
      else if (this.filter === 'starred') {
        query = query.where('starred', '==', true)
        imagesLen = this.starredImagesLen
      }

      if (this.customSearch !== null) {
        if (this.customSearch.name) {
          query = query.orderBy('name').startAt(this.customSearch.name).endAt(this.customSearch.name+'\uf8ff')
        }
        else if (this.customSearch.id) {
          query = query.orderBy(firebase.firestore.FieldPath.documentId()).startAt(this.customSearch.id).endAt(this.customSearch.id+'\uf8ff')
        }
        else if (this.customSearch.number) {
          query = query.where("numbers", "array-contains", this.customSearch.number)
        }
        else if (this.customSearch.list) {
          query = query.where("search", "array-contains", this.customSearch.list)
        }
      }
      else {
        if (sortBy && sortBy.length) {
          sortByField = sortBy[0]
          // console.log('sortByField', sortByField)
          if (sortByField === 'id') {
            if (sortDesc && sortDesc.length && sortDesc[0] === true) {
              query = query.orderBy(firebase.firestore.FieldPath.documentId(), 'desc')
            }
            else {
              query = query.orderBy(firebase.firestore.FieldPath.documentId())
            }          
          }
          // else if (sortByField === 'detectTextState') {
          //   query = query.orderBy(firebase.firestore.FieldPath.documentId())
          // }
          else if (sortDesc && sortDesc.length && sortDesc[0] === true) {
            query = query.orderBy(sortByField, "desc")
            // query = query.orderBy(firebase.firestore.FieldPath.documentId())
          }
          else {
            query = query.orderBy(sortByField)
            // query = query.orderBy(firebase.firestore.FieldPath.documentId())
          }

          if (sortByField === 'reviewed_sort' || sortByField === 'numbers_ok_sort') {
            query = query.orderBy('name')
          }
        }
        else {
          query = query.orderBy('name')
        }
      }
      
      
      

      let reset = false
      let startAfter = ''
      let startAfterName = ''
      if ((this.customSearch && this.customSearchInfo !== this.customSearch.info) || this.filter !== this.filterInfo || sortBy !== this.sortByInfo || sortDesc !== this.sortDescInfo || itemsPerPage !== this.itemsPerPageInfo) {
        reset = true
        this.pagesInfo = ['']
        this.pagesInfoName = ['']
      }
      else if (page > 1) {
        startAfter = this.pagesInfo[page - 1];
        startAfterName = this.pagesInfoName[page - 1];
      }
      else {
        startAfter = '';
        startAfterName = '';
      }

      this.filterInfo = this.filter;
      this.sortByInfo = sortBy;
      this.sortDescInfo = sortDesc;
      this.itemsPerPageInfo = itemsPerPage;

      if (this.customSearch == null) {
        if (page > 1) {
          if (sortByField === 'reviewed_sort' || sortByField === 'numbers_ok_sort') {
            query = query.startAfter(startAfter, startAfterName)
          }
          else {
            query = query.startAfter(startAfter)
          }
          
        }
        
        query = query.limit(itemsPerPage || 50)
      }

      
      
      const docs = await query.get()

      const imagesArray = [];
      docs.forEach((doc) => {
        let image = doc.data();
        image.id = doc.id;
        image.detectTextState = this.setDetectTextState(image);
        image['exif.createDate'] = image.exif ? image.exif.createDate : null
        imagesArray.push(image);        
      })


      if (imagesArray.length && this.pagesInfo.length === page) {
        const last = imagesArray[imagesArray.length - 1]
        let field = sortBy[0] || 'name'
        this.pagesInfo.push(last[field]);
        this.pagesInfoName.push(last.name);
      }

      if (this.filter === 'selected') {
        this.images = imagesArray.filter(
          (i) => this.selected.find((s) => s.id == i.id) != null
        );
      }
      else {
        this.images = imagesArray
      }

      
      this.totalImages = this.filter === '' ? this.totalImagesInit : imagesLen
      if (this.totalImages < 0) {
        this.totalImages = this.images.length
      }
      
      this.loadingImages = false

    },
    editGallery() {
      this.$router.push("/gallery-edit/" + this.galleryId);
    },
    setDetectTextState(image) {
      if (image.detectText === "pending") {
        return "spin";
      }
      if (image.detectText === "pending") {
        return "is-warning";
      }
      if (
        image.detectText === "done-ok" &&
        image.numbers &&
        image.numbers.length > 0
      ) {
        return "is-success";
      }
      return "is-warning";
    },
    async viewGallery() {
      fb.galleriesCollection
        .doc(this.galleryId)
        .get()
        .then(async (doc) => {
          if (doc.exists) {
            this.gallery = doc.data();
            this.gallery.id = this.galleryId;
            this.galleryName = this.gallery.name;

            if (this.gallery.photos < 10) {
              let query = await fb.imagesCollection.where("galleryId", "==", this.galleryId)
              query.get().then(async (allDocs) => {
                this.totalImages = allDocs.size;
                this.totalImagesInit = allDocs.size;
                if (allDocs.size > 0) {
                  fb.galleriesCollection.doc(this.galleryId).update({ photos: allDocs.size })
                }                
              })              
            }
            else {
              this.totalImages = this.gallery.photos;
              this.totalImagesInit = this.totalImages;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onUploaded(info) {
      console.log("onUploaded info", info);
    },
    selectNoneImages() {
      this.selected = [];
    },
    selectAllImages() {
      this.selected = [];

      this.images.forEach((i) => {
        this.selected.push(i);
      });
    },
    selectImage(image) {
      if (this.selected.find((s) => s.id == image.id) != null) {
        this.selected = this.selected.filter((s) => s.id !== image.id);
      } else {
        this.selected.push(image);
      }
    },
    async deleteFiles() {
      if (this.userProfile.role !== 'admin') {
        return
      }
      if (this.selected.length > 0) {
        const result = await this.$swal({
          title: "¿Borrar?",
          text: `¿Está seguro de borrar ${this.selected.length} fotos?`,
          icon: "question",
          confirmButtonText: "Sí",
          showCancelButton: true,
          cancelButtonText: "No",
        });

        if (result.value) {
          let selected = JSON.parse(JSON.stringify(this.selected));
          // let counter = 0
          selected.forEach(async (img) => {
            const image = this.images.find((gi) => gi.id === img.id);
            if (image) {
              // const res = await fb.imagesCollection.doc(img.id).delete();
              const res = await fb.imagesCollection.doc(img.id).update({ galleryId: `deleted_${this.galleryId}` });
              // counter++

              // await deleteFile("galleries", this.galleryId, image.name).catch(
              //   (e) => {
              //     console.error("deleteFile not found", img.id);
              //   }
              // );

              console.log("deleteFile done", img.id);
              this.shouldUpdateCounters = true
            }
          });

          await fb.galleriesCollection.doc(this.galleryId).update({ photos: firebase.firestore.FieldValue.increment(-1 * selected.length) })

          this.selected = [];
          //this.reloadImageView()
          this.shouldUpdateCounters = true
          this.tableView = true
        }
      }
    },
    async detectText() {
      if (this.userProfile.role !== 'admin') {
        return
      }
      if (this.selected.length > 0 && !this.detectingText) {
        const result = await this.$swal({
          title: "¿Detectar Texto?",
          text: `¿Quiere detectar texto en ${
            this.selected.length > this.maxElements
              ? this.maxElements
              : this.selected.length
          } fotos?`,
          icon: "question",
          confirmButtonText: "Sí",
          showCancelButton: true,
          cancelButtonText: "No",
        });

        if (result.value) {
          let times = 0;

          this.selected.forEach(async (image) => {
            console.log("image", image);
            if (image) {
              times++;

              const res = await fb.imagesCollection.doc(image.id).update({
                detectText: "pending",
              });

              await this.callTextDetection(image.id);
              this.shouldUpdateCounters = true
            }
          });

          this.selected = [];
        }
      }
    },
    filterImages(filter) {
      // console.log('this.filterInfo',this.filterInfo)
      // console.log('filter',filter)
      if (this.filterInfo !== filter) {
        // console.log('this.tableOptions', this.tableOptions)
        this.tableOptions.page = 1
      }
      this.filter = filter;
      this.customSearch = null
      // if (this.filter == "pending" || this.filter == "none") {
      //   this.selected = [];
      // }
      if (this.filter !== "selected" && this.filter !== "zzzzxccc") {
        this.selected = [];
      }
      // this.reloadImageView();
      this.getImages();
    },
    reset() {
      this.selected.forEach(async (id) => {
        const res = await fb.imagesCollection.doc(id).update({
          detectText: "pending",
        });
      });
    },
    showPopup(image) {
      EventBus.$emit('image-popup', {
        url: null,        
        gallery: this.gallery,
        images: [image],
        currentVisibleItems: this.currentVisibleItems
      });
    },
    showSearchPopup(image) {
      EventBus.$emit('search-popup', { gallery: this.gallery });
    },
    async deleteDetection(id) {
      const result = await this.$swal({
        title: "¿Borrar detección de texto?",
        text: `¿Está seguro de borrar la detección de texto?`,
        icon: "question",
        confirmButtonText: "Sí",
        showCancelButton: true,
        cancelButtonText: "No",
      });

      if (result.value) {
        await fb.imagesCollection.doc(id).update({
          detectText: "pending",
          texts: [],
          numbers: [],
          numbers_ok: false,
          numbers_ok_sort: '0',
        });
        await this.callTextDetection(id);
      }
    },
    async callTextDetection(id) {
      axios
        .get(
          `${process.env.VUE_APP_API}detect?galleryId=${this.galleryId}&imageId=${id}`
        )
        .then((result) => {
          //console.log("galleryDetectText", result.data);
        });
    },
    onDataFooterUpdate(options) {
      this.tableOptions = options;
    },
    currentItems(items) {
      this.currentVisibleItems = items
      // console.log('items', items)
      if (this.reloadView) {
        this.reloadView = false;
        this.tableView = false
      }
    },
    pagerPrev() {
      this.tableOptions.page--;
      this.reloadImageView();

    },
    pagerNext() {
      this.tableOptions.page++;
      this.reloadImageView();
    },
    editMultiple() {
      if (this.userProfile.role !== 'admin') {
        return
      }
      if (this.selected.length > 0) {
        EventBus.$emit('image-popup', { images: this.selected, gallery: this.gallery, currentVisibleItems: this.currentVisibleItems });
      }      
    },
    reloadImageView() {
      if (!this.tableView) {
        this.reloadView = true;
      }
      this.tableView = true;
    },
    canSearchClick() {
      this.canSearch = !this.canSearch;

      // if (!this.canSearch) {
      //   this.search = ''
      //   this.reloadImageView()
      // }
      // else {
      //   setTimeout(() => {
      //     var e = document.getElementById('search')
      //     if (e) {
      //       e.focus();
      //     }
      //   }, 250)
      // }
    },
    modalClosed() {
      // console.log('modalClosed')
      this.getImages();
    },
    doSearch(info) {
      // console.log('doSearch', info)
      this.filter = 'custom' + Math.random() * 1000
      this.tableOptions.page = 1
      // this.customSearchInfo = 'custom' + Math.random() * 1000
      this.customSearch = info
      this.customSearch.info = this.customSearchInfo
      this.getImages()
    },
    debouncedFilter: debounce(function(value){
      this.search = value;
    }, 800),
    searchChange: debounce(function (e) {
      // console.log('searchChange', e)
      this.reloadImageView()
    }, 400)
    
  },
};
</script>
<style scoped>
.brand{
  width: calc(100px + 0.5rem);
  margin-left: -0.5rem;
  margin-top: 4px;
}
.title {
  margin-top: 1.1rem;
  margin-left: 1rem;
}
.card-image {
  max-height: 200px;
  width: 100%;
}
.card {
  font-size: 0.85rem;
  border: 2px solid transparent;
  position: relative;
}
.card-text {
  padding: 0.5rem;
}
.gallery {
  margin-top: 1rem;
}
.card:hover {
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.2);
}
.buttons {
  margin-top: 1.5rem;
  text-align: right;
}
.buttons i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}
.card-selected {
  border: 2px solid #3298dc;
}
.input {
  border: 0;
  border-radius: 0;
  border-bottom: 2px solid hsl(0, 0%, 71%);
  outline: none;
  font-size: 1.5rem;
}
.input:focus,
.input:active {
  border-bottom: 2px solid hsl(171, 100%, 41%);
  outline: none;
  box-shadow: none;
}
.stats {
  color: #6c757d;
  margin-bottom: 1rem;
}
.stats .tag {
  margin-right: 0.5rem;
  cursor: pointer;
  font-size: 0.9rem;
}
.stats .tag.tag-selected {
  font-weight: bold;
}
.tag-circle {
  border-radius: 50%;
  width: 26px;
  height: 26px;
  opacity: 0.9;
}
.tag-circle i {
  font-size: 16px;
}
</style>
<style>
.v-data-table-header th.sortable {
  padding-top: 12px !important;
}
.v-data-table table tbody tr td {
  padding-top: 14px !important;
  color: #6c757d !important;
  cursor: pointer;
  font-size: 0.85rem !important;
}
.row-v-data-table {
  padding-bottom: 2rem !important;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding-top: 8px !important;
}
.sub-header {
  position: fixed;
  width: 100%;
  top: 0px;
  border-bottom: 2px solid #eee;
  z-index: 10;
  background-color: #fff;
  left: 0;
  padding: 0 1.5rem;

}
#gallery {
  margin-top: 160px;
}
.pager{
font-size: 30px;
}
.pager.disabled{
color:#ccc;
}
.flex {
  display: flex;
}
.search-input{
  display: inline-block;
  width: 150px;
  box-shadow: none;
  font-size: 0.8rem!important;
  padding: 0 4px;
}
.spin {
  animation-name: spin;
  animation-duration: 2000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear; 
  vertical-align:-6px;
}
@keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
}
</style>